import React from 'react';

import { NetworkSlug } from 'domain/types';

import { NetworkIcon } from '../NetworkIcon';
import { ExternalLinkButton } from '../ExternalLinkButton';

const explorerNames: Record<string, string> = {
  default: 'Etherscan',
  mainnet: 'Etherscan',
  'arbitrum-one': 'Arbiscan',
  polygon: 'PolygonScan',
  avalanche: 'Snowtrace',
  optimism: 'OptimismScan',
  fantom: 'FTMScan',
  bsc: 'BscScan',
  harmony: 'Harmony Explorer',
  moonbeam: 'Moonbeam Explorer',
  moonriver: 'Moonriver Explorer',
  gnosis: 'Gnosis Explorer',
  base: 'BaseScan',
  aurora: 'Aurora Explorer',
  'zksync-era': 'zkSync Era Explorer',
  manta: 'Manta Pacific Explorer',
  linea: 'Linea Mainnet Explorer',
};

export function EtherscanLinkButton({ href, network }: { href: string; network: NetworkSlug }) {
  return (
    <ExternalLinkButton
      href={href}
      tooltip={`Open in ${explorerNames[network] || explorerNames.default}`}
      icon={<NetworkIcon slug={network} fontSize="inherit" variant="explorer" />}
      onClick={e => {
        e.stopPropagation();
      }}
    />
  );
}
